import { createContext } from "react";

type CardContextType = {
  isFocused: boolean;
  handleFocus: (value: boolean) => void;
};

const CardContext = createContext<CardContextType>({
  isFocused: false,
  handleFocus: () => undefined
});

export { CardContext };
